import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

import { PageContent, TableSkeleton } from '../index';

const loaderContainerSx: SxProps<Theme> = (theme: Theme) => ({
  width: '100%',
  height: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    px: 2,
  },
  [theme.breakpoints.down('sm')]: {
    px: 1.25,
    maxWidth: 350,
  },
});

interface IGridViewLoaderProps {
  height?: string;
}

export const TableViewLoader: React.FC<IGridViewLoaderProps> = ({ height = 'calc(100vh - 300px)' }) => {
  return (
    <PageContent>
      <Box sx={loaderContainerSx}>
        <TableSkeleton height={height} />
      </Box>
    </PageContent>
  );
};
